"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterFormItems = filterFormItems;
exports.JsonComponent = void 0;

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _vuePropertyDecorator = require("vue-property-decorator");

var _transformLang = require("../utils/transformLang");

var _linkApi = require("../utils/linkApi");

var _formApi = require("../apis/formApi");

var _locale = require("../locale");

var _vueJsonView = require("vue-json-view");

var _dec, _dec2, _dec3, _dec4, _dec5, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function filterFormItems(formItems, showNames) {
  var pre = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  if (!showNames.length) {
    return formItems;
  }

  var result = [];
  formItems.forEach(function (item) {
    // 子表单
    if (item._type && item._type.type === 'objectArray') {
      var path = item._type.path;

      var children = _vueJsonView.Utils.getDataByName(item, path);

      var filteredChildren = filterFormItems(children, showNames, pre + item.name + '.');

      if (filteredChildren.length) {
        result.push(_vueJsonView.Utils.setDataByObj(item, (0, _defineProperty2.default)({}, path, filteredChildren)));
      }
    } else if (showNames.includes(pre + item.name)) {
      // 存在该字段
      result.push(item);
    }
  });
  return result;
}

var JsonComponent = (_dec = (0, _vuePropertyDecorator.Prop)(), _dec2 = (0, _vuePropertyDecorator.Prop)(), _dec3 = (0, _vuePropertyDecorator.Prop)(), _dec4 = (0, _vuePropertyDecorator.Prop)(), _dec5 = (0, _vuePropertyDecorator.Watch)('json', {
  immediate: true
}), (0, _vuePropertyDecorator.Component)(_class = (_class2 = (_temp = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(JsonComponent, _Vue);

  var _super = _createSuper(JsonComponent);

  function JsonComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, JsonComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _initializerDefineProperty2.default)(_this, "formId", _descriptor, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "json", _descriptor2, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "filterType", _descriptor3, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "getForm", _descriptor4, (0, _assertThisInitialized2.default)(_this));
    _this.privateJson = '';
    _this.formLoading = false;
    _this.beforeFormItems = [];
    _this.formProperty = {};
    _this.getFormPromise = null;
    _this.taskList = [];
    return _this;
  }

  (0, _createClass2.default)(JsonComponent, [{
    key: "type",
    get: function get() {
      return '';
    }
  }, {
    key: "formItems",
    get: function get() {
      // 多语言转化
      return (0, _transformLang.transformLang)(this.beforeFormItems, (0, _locale.getLang)(), true);
    }
  }, {
    key: "jsonChange",
    value: function jsonChange(json) {
      var _this2 = this;

      if (!json) {
        return;
      }

      var form = JSON.parse(json);
      var formItems = form.children || []; // 过滤字段

      var show = form._show || {};
      var filterList = show[this.filterType || this.type] || [];
      formItems = filterFormItems(formItems, filterList); // 异步请求数据

      this.taskList = (0, _linkApi.linkApi)(formItems, function (item, i) {
        return _this2.$set(_this2.beforeFormItems, i, item);
      });
      this.beforeFormItems = formItems;
      this.formProperty = _objectSpread({}, form);
    }
  }, {
    key: "created",
    value: function created() {
      var _this3 = this;

      var formId = this.formId,
          json = this.json;
      var getForm = this.getForm || _formApi.FormApi.getForm;
      this.formLoading = true;

      if (json === undefined && formId) {
        this.getFormPromise = getForm(formId).then(function (resForm) {
          _this3.privateJson = JSON.stringify(resForm);

          _this3.jsonChange(_this3.privateJson);
        }).finally(function () {
          return _this3.formLoading = false;
        });
      }
    }
  }]);
  return JsonComponent;
}(_vuePropertyDecorator.Vue), _temp), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "formId", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "json", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "filterType", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "getForm", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "jsonChange", [_dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "jsonChange"), _class2.prototype)), _class2)) || _class);
exports.JsonComponent = JsonComponent;